import type {
  ArchivedDocumentDetail,
  ArchiveSearchResponse,
} from "../types";
import { apiFetch, apiFetchBlob, type ApiBlobResponse } from "./client";

export const ARCHIVE_PAGE_SIZE = 50;

/** API の必須3項目。空文字は送らず、backend の未指定と同じ意味にする。 */
export interface ArchiveSearchCriteria {
  date_from: string;
  date_to: string;
  amount_min: string;
  amount_max: string;
  counterparty: string;
}

export const EMPTY_ARCHIVE_CRITERIA: ArchiveSearchCriteria = {
  date_from: "",
  date_to: "",
  amount_min: "",
  amount_max: "",
  counterparty: "",
};

export function listArchivedDocuments(
  criteria: ArchiveSearchCriteria,
  offset = 0,
): Promise<ArchiveSearchResponse> {
  return apiFetch<ArchiveSearchResponse>("/api/archive/documents", {
    query: {
      ...queryFor(criteria),
      limit: ARCHIVE_PAGE_SIZE,
      offset,
    },
  });
}

export function getArchivedDocument(
  documentId: number,
  verify = false,
): Promise<ArchivedDocumentDetail> {
  return apiFetch<ArchivedDocumentDetail>(`/api/archive/documents/${documentId}`, {
    query: verify ? { verify: "true" } : undefined,
  });
}

export function getArchivedDocumentContent(
  documentId: number,
  download = false,
): Promise<ApiBlobResponse> {
  return apiFetchBlob(`/api/archive/documents/${documentId}/content`, {
    query: download ? { download: "true" } : undefined,
  });
}

export function exportArchivedDocuments(
  format: "csv" | "zip",
  criteria: ArchiveSearchCriteria,
): Promise<ApiBlobResponse> {
  return apiFetchBlob(`/api/archive/documents.${format}`, {
    // 一覧の offset は送らない＝検索条件に一致する全件が出力対象。
    query: queryFor(criteria),
  });
}

export function exportEvidencePack(): Promise<ApiBlobResponse> {
  return apiFetchBlob("/api/archive/evidence-pack.zip");
}

function queryFor(criteria: ArchiveSearchCriteria): Record<string, string | undefined> {
  return Object.fromEntries(
    Object.entries(criteria).map(([key, value]) => [key, value.trim() || undefined]),
  );
}
